export const EMAIL_REGEX =
	/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

export const OTP_REGEX = /^\d{6}$/

export const validateEmail = (email: string): string | null => {
	if (!email) return "Email is required"
	if (!EMAIL_REGEX.test(email)) return "Please enter a valid email address"
	return null
}

export const validateOTPCode = (code: string): string | null => {
	if (!code) return "OTP code is required"
	if (!OTP_REGEX.test(code)) return "OTP code must be 6 digits"
	return null
}
